export const SUPRA_APPLET_UID = '@signageos/supra-screen';

export const DEFAULT_SUPRA_SCREEN_APPLET_VERSION = 'latest'; // TODO it might be provided by build config in future
export const DEFAULT_SUPRA_APP_NAME = '/opt/signageos-display-supra/@signageosdisplay-supra';
export const DEFAULT_SUPRA_SERVER_STATUS_PORT = 6112;
